import FileUpload from './file_upload/file_upload_unpoly';
import i18n from '../i18n';
window.up.compiler('.js-file_upload', function (element) {
    new FileUpload(element);
});
window.up.compiler('.js-text_file_upload', fileInput => {
    window.up.on(fileInput, 'change', undefined, () => {
        const files = fileInput.files;
        if (files) {
            const file = files[0];
            const container = fileInput.closest('.js-text_file_upload_container');
            const filenameElement = container === null || container === void 0 ? void 0 : container.querySelector('.js-text_file_upload_filename');
            if (file && filenameElement) {
                filenameElement.innerHTML = file.name;
            }
            const headersElement = container === null || container === void 0 ? void 0 : container.querySelector('.js-text_file_upload_headers');
            if (file && headersElement) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    var _a;
                    const fullText = reader.result; // readAsText will make the result a string
                    const headers = (_a = fullText === null || fullText === void 0 ? void 0 : fullText.split('\n').shift()) === null || _a === void 0 ? void 0 : _a.trim();
                    if (headers) {
                        const message = i18n.$gettext('Here is the first line of your file. That line determines the column names and separator: "%{names}"', { names: headers });
                        headersElement.innerHTML = message;
                    }
                };
                reader.readAsText(file); // triggers onloadend
            }
        }
    });
});
